import styled from 'styled-components'

import { Array } from '@blade/std-lib'
import { TransactionListItemSkeleton } from '@root/entities/transaction/ui'

import type { ClassNameProps } from '@root/shared/react'

type TransactionHistoryListLoadingProps = {
  withWallet?: boolean
} & ClassNameProps

export const TransactionHistoryListLoading = ({
  withWallet = false,
  ...props
}: TransactionHistoryListLoadingProps) => (
  <Root {...props}>
    {Array.range(1, 3).map((it) => (
      <Item key={it} withWallet={withWallet} />
    ))}
  </Root>
)

const Root = styled.div`
  display: grid;
  gap: 8px;
  margin: 8px 6px 8px;
`

const Item = styled(TransactionListItemSkeleton)`
  background: var(--tx-background-color, var(--background-1));
`
